import { Link } from "react-router-dom";
import Dialog from "../../../components/Dialog";
import { Profile } from "../../../services/profile/profileModel";
import { useTranslation } from "react-i18next";
import Logo from "../../../assets/logo-2mm-header.png";

const SharedInvitationDialog = ({
  uid,
  profile,
}: {
  uid: string;
  profile: Profile;
}) => {
  const { t } = useTranslation(["organization"]);

  return (
    <Dialog className="--shared" modal>
      <div className="popup_body lcol --center--h">
        <div>
          <img className="logo" src={Logo} alt="logo" />
        </div>
        <div className="intro --txt--center">
          {t("organization:shared-profile.dialog.INTRO", {
            replace: {
              firstname: profile.user!.firstname,
              lastname: profile.user!.lastname,
            },
          })}
        </div>
        <div className="--txt--center">
          <h2 className="title--30">
            {t("organization:shared-profile.dialog.ALREADY_HAVE_AN_ACCOUNT")}
          </h2>
          <div className="cblock">
            <Link className="btn--1 --btn" to={`/login?uid=${uid}`}>
              {t("organization:shared-profile.dialog.LINK_LOGIN")}
            </Link>
          </div>
        </div>
        <div className="--txt--center">
          <h2 className="title--30">
            {t("organization:shared-profile.dialog.NEW_TO_2MM")}
          </h2>
          <div className="cblock lcol --center--h">
            <div className="plan-features-list --txt--left">
              <div className="feature">
                {t("organization:shared-profile.dialog.FREE_ACCESS_ARGUMENT")}
              </div>
              <div className="feature">
                {t(
                  "organization:shared-profile.dialog.SECURE_PLATFORM_ARGUMENT",
                )}
              </div>
            </div>
          </div>
          <div className="cblock">
            <Link
              className="btn--2 --btn"
              to={`/register/organization?uid=${uid}`}
            >
              {t("organization:shared-profile.dialog.CREATE_FREE_ACCOUNT")}
            </Link>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default SharedInvitationDialog;
